import { Pressable, Text } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { ActivityIndicator, Image, ImageSourcePropType, StyleSheet, TextStyle, ViewStyle } from 'react-native'
import { iconFont } from '../../services/Icon'
import { IconType } from '../../services/weather'
import { theme } from '../../theme'

interface Props {
  onPress: () => void
  iconName?: string
  iconType?: IconType
  iconSize?: number
  image?: ImageSourcePropType
  label: string
  style?: ViewStyle
  textStyle?: TextStyle
  loading?: boolean
  disabled?: boolean
}

export const Button: FunctionComponent<Props> = ({ onPress, label, iconName, iconType, iconSize = 24, image, style, textStyle, loading, disabled }) => {
  const IconComponent = iconFont(iconType || '')

  return (
    <Pressable onPress={onPress} style={[styles.button, style, disabled && styles.disabled]} disabled={disabled}>
      {!!image && <Image style={styles.buttonImage} source={image} resizeMode="contain" />}
      {!!iconName && <IconComponent name={iconName} size={iconSize} color={theme.colors.white} style={styles.buttonIcon} />}
      {loading ? <ActivityIndicator color={theme.colors.white} /> : <Text style={[styles.label, textStyle]}>{label}</Text>}
    </Pressable>
  )
}

const styles = StyleSheet.create({
  button: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: theme.padding.x3,
  },
  buttonIcon: {
    position: 'absolute',
    fontSize: theme.iconSize.x1,
    marginLeft: theme.padding.x2,
    left: 0,
  },
  buttonImage: {
    position: 'absolute',
    left: 0,
    width: 25,
    height: 25,
    marginLeft: theme.padding.x2,
  },
  label: {
    color: theme.colors.white,
    fontWeight: 'bold',
  },
  disabled: {
    opacity: 0.5,
  },
})
